<template>
    <div class="stationBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer :selectList="selectList" :request-form="selectForm" @search="getResult"/>
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            @handleSelectionChange="bachOper"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
        <!-- 弹窗(添加) -->
        <ots-custom-dialog :dialog.sync="addDialog" :title="form.code?'修改':'添加教学点'" width="40%">
          <template v-slot:content>
            <div>
              <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="请选择教学点所属学校" class="childrenName" prop="schoolId">
                  <el-select v-model="form.schoolId" placeholder="请选择">
                    <el-option v-for="item in allSchoolInfo" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="教学点名称" class="childrenName" prop="name">
                  <el-input v-model.trim="form.name" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="启用状态">
                  <el-radio-group v-model="form.state">
                    <el-radio-button label=1>启用</el-radio-button>
                    <el-radio-button label=0>停用</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="addDialog=false">取消</el-button>
            <el-button round type="primary" @click="addStation">确定</el-button>
          </template>
        </ots-custom-dialog>
        <!-- 弹窗(导入) -->
        <ots-custom-dialog :dialog.sync="importDialog" title="导入教学点" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form ref="exportForm" :model="importForm">
                <el-form-item label="1.模板下载">
                  <span style="color:#006AFF;" @click="$getStaticFile('教学点导入.xlsx')" class="cp">
                      <i class="el-icon-download"></i>
                      下载教学点导入数据模板
                  </span>
                </el-form-item>
                <el-form-item label="2.选择文件" v-model="importForm.file">
                  <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                </el-form-item>
              </el-form>
              <div class="impExplain">
                <span class="tipTitle"><i></i>提示：</span>
                <div>
                  <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                  <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importDialog=false">取消</el-button>
            <el-button round type="primary" @click="rightImport">确定</el-button>
          </template>
        </ots-custom-dialog>
    </div>
</template>
<script>
import { getAllStation, addStationFn, updateStationFn, deleteStationFn, updateStationStateFn, importStationFn,exportStationFn } from '@/http/modules/baseSet/station'
import { mapActions } from 'vuex'
export default {
  name: 'station',
  data () {
    return {
      updataSelectStationFlag: false,
      /* ** 选中教学点 ID ** */
      selectIds: [],
      /* ** 表单配置 ** */
      selectList: [
        {
          title: "状态",
          type: "select",
          requestKey: "state",
          label: 'key',
          value: 'value',
          data: [
            { key : '全部', value : -1 },
            { key : '启用', value : 1 },
            { key : '停用', value : 0 }
          ],
        },
        {
          title: "所属学校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
          ],
        },
        {
          title : '教学点名称',
          type : 'input',
          placeholder : '请输入教学点名称',
          requestKey: "searchKey"
        }
      ],
      /* ** 表单参数 ** */
      selectForm: {
        state : -1,
        schoolId : this.$route.query.searchId || '',
        searchKey : '',
      },
      /* ** 表格头配置 ** */
      tableHeader: [
        {
          title: "教学点名称",
          prop: "name"
        },
        {
          title: "所属学校",
          prop: "schoolName"
        },
        {
          title:"启用状态",
          prop:"state",
          type:"switch",
          switchChange:this.changeStationState
        },
        {
          title:"操作",
          type:"buttons",
          width:"100",
          btnList:[
            { title:"编辑", click: this.editStation },
            { title:"删除", click: this.deleteStation },
          ]
        }
      ],
      /* ** 表格开启选中样式 ** */
      tableOption: {
        multiple:true
      },
      /* ** 删除按钮 ** */
      batchOperBtn:[
        {
          title: "删除",
          icon: "iconfont icon-shanchu",
          click: this.deleteStation
        },
      ],
      /* ** 表格数据 ** */
      tableData: [],
      /* ** 新增/编辑 参数 ** */
      form: {
        schoolId: '',
        name: '',
        state: 1,
      },
      /* ** 导入文件参数 ** */
      importForm: {
        file: ''
      },
      /* ** 校验规则 ** */
      rules: {
        schoolId: [
          { required: true, message: '请选择所属学校', trigger: 'blur'}
        ],
        name: [
          { required: true, message: '请输入教学点名称', trigger: 'blur'}
        ]
      },
      /* ** 新增/导入 按钮 ** */
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.addStationDialog,
          plain: true
        },
        {
          title: '导入',
          fn: this.importStationDialog
        },
        {
          title: '导出',
          fn: this.exportExcel
        }
      ],
      /* ** 添加/编辑 弹窗 ** */
      addDialog: false,
      /* ** 导入弹窗 ** */
      importDialog: false,
      /* ** 数据总数(分页) ** */
      pagination: {
        total: 0
      },
      /* ** 分页参数 ** */
      StationListParams: {
        orders: 'createDate desc',
        page: 1,
        size: 10
      },
      allSchoolInfo: [],
    }
  },
  created () {
    this.getAllSchoolFn();
    this.getAllStationFn()
  },
  beforeDestroy () {
    if (this.updataSelectStationFlag) {
      this.getSelectStationAction()
    }
  },
  methods: {
    ...mapActions('selectOptions', ['getSelectStationAction']),

    /**********************************
     * @bachOper 勾选 Id 拼接
     **********************************/
    bachOper (val) {
      let idList=[]
      val.forEach(item=>{
          idList.push(item.id)
      })
      this.selectIds = idList
    },

    /**********************************
     * @addStationDialog 添加/编辑弹窗
     **********************************/
    addStationDialog () {
      this.resetForm();
      this.addDialog = true
    },

    /**********************************
     * @importStationDialog 导入弹窗
     **********************************/
    importStationDialog () {
      this.importDialog = true
    },

    /**********************************
     * @addStation 添加/编辑操作
     **********************************/
    addStation () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // (1) 参数
          let params = { ...this.form }
          // (2) 删除 "form_" 开头参数
          for (let key in params) {
            if (key.startsWith('form_')) { delete params[key] }
          }
          // (3) 编辑 ? 添加 ?
          const useFn = params.id ? updateStationFn : addStationFn
          // (4) 编辑|添加接口
          const { code } = await useFn(params)
          if (code ==  1) {
            this.$message.success('操作成功')
            this.updataSelectStationFlag = true
            this.addAfter()
          }
        } else {
          return false
        }
      });
    },

    /**********************************
     * @editStation 编辑按钮
     **********************************/
    editStation (row) {
      this.form = Object.assign(this.form, row)
      this.addDialog = true
    },

    /**********************************
     * @editStation 教学点是否勾选
     **********************************/
    beforeBatch () {
      if (this.selectIds.length > 0) {
        return true
      } else {
        this.$message.warning('请先选择教学点')
        return false
      }
    },

    /**********************************
     * @deleteStation 批量删除
     **********************************/
    deleteStation (row) {
      // (1) 是否勾选教学点
      if (!(row || this.beforeBatch())) {
        return false
      }
      // (2) Id 拼接参数
      let param = {
        ids: row ? row.id : this.selectIds.join()
      }
      // (3) 删除确认弹窗
      this.$confirm('确定删除该教学点?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code } = await deleteStationFn(param)
          if (code == 1) {
            this.$message.success('删除成功')
            this.updataSelectStationFlag = true
            this.getAllStationFn()
          }
        })
    },

    /**********************************
     * @changeStationState 修改教学点启用状态
     **********************************/
    async changeStationState (row) {
      let param = {
        id: row.id,
        state: row.state
      }
      const { code } = await updateStationStateFn(param)
      if (code == 1) {
        this.$message.success('修改成功')
        this.updataSelectStationFlag = true
      }
    },

    /**********************************
     * @getAllSchoolFn 获取查询条件中学校下拉框的数据
     **********************************/
    async getAllSchoolFn () {
      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [{ id: "", name: "全部" }, ...data]
        this.allSchoolInfo = data;
        this.$set(this.selectList[1], "data", newSchoolList);
      })
    },

    /**********************************
     * @getAllStationFn 获取表格数据
     **********************************/
    async getAllStationFn () {
      this.StationListParams = Object.assign(this.StationListParams, this.selectForm)
      const { data } = await getAllStation(this.StationListParams)
      this.tableData = data.records
      this.pagination.total = data.total
    },

    /**********************************
     * @resetFormc 重置新增/编辑表单
     **********************************/
    resetForm() {
      this.form = {
        schoolId: '',
        name: '',
        state: 1,
      }
    },

    /**********************************
     * @addAfter 关闭弹窗
     **********************************/
    addAfter () {
      this.addDialog = false
      this.resetForm()
      this.getAllStationFn()
    },

    /* *** 分页相关 *** */
    changeSize(num) {
        this.StationListParams.size=num
        this.getAllStationFn()
    },

    /* *** 分页相关 *** */
    changePage(p) {
        this.StationListParams.page=p
        this.getAllStationFn()
    },

    /**********************************
     * @getResult 搜索表单查询
     **********************************/
    getResult () {
      this.StationListParams.page = 1
      this.getAllStationFn()
    },

    /**********************************
     * @handleFormData 配置文件参数
     **********************************/
    handleFormData (val) {
        this.importForm.file = val.file
    },

    /**********************************
     * @rightImport 文件上传功能
     **********************************/
    async rightImport () {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error('请选择文件')
        return
      }
      const fd = new FormData()
      for (let item in this.importForm) {
        fd.append(item,this.importForm[item])
      }
      const { code, data } = await importStationFn(fd)
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0
        const totalNum = parseInt(data.allCount)
        const successNum = totalNum - failNum
        let message = `导入完成，成功导入${successNum}，失败数${failNum}`
        this.importDialog = false
        this.$confirm(message, '导入结果', {
            confirmButtonText: failNum > 0 ? '查看错误记录' :'确定',
            cancelButtonText: '取消',
            type: failNum > 0 ? 'warning' :'success'
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address
          }
        })
        this.getAllStationFn()
        this.updataSelectStationFlag = true
      }
    },
    async exportExcel () {
      const { data, code } = await exportStationFn(this.selectForm);
      if (code) {
        window.open(data);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.stationBox {
  .searchCon {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
</style>
